<template>

<div class="form__wrap form__wrap__group">
	<div class="form__wrap__group">
		<label>{{ 'segment-by' | translate | capitalize }}</label>
		<select v-model="segment" @change="getFilter()">
			<option  v-for="segment in segments" :key="segment" :value="segment">{{ segment| translate }}</option>
		</select>
	</div>
	<div class="form__wrap__group" v-if="user.organization.is_mandatoaberto">
		<label>{{ 'question' | translate | capitalize }}</label>
		<select :disabled="segment === 'intent' || segment.length === 0" v-model="pollAndQuestion"
		@change="getAnswers()">
			<optgroup :label="poll.name" v-for="poll in polls" :key="poll.id" v-if="segment === 'poll'">
				<option :value="`${poll.id}:${question.id}`" v-for="question in poll.questions" :key="question.id">{{question.content}}</option>
			</optgroup>
		</select>
	</div>
	<div class="form__wrap__group">
		<label>{{ 'condition' | translate | capitalize }}</label>
		<select

			v-model="condition" @change="updateValue()"
			:disabled="segment.length === 0">
			<option v-for="(condition, index) in availableConditions" :key="condition[index]" :value="condition.name">{{ condition.name | translate | capitalize }}</option>
		</select>
	</div>
	<div class="form__wrap__group">
	<label>{{ segment === 'poll' ? 'resposta' : 'tema' | translate | capitalize }}</label>
		<select v-model="value" @change="updateValue()" :disabled="condition.length === 0">
			<option v-for="answer in availableAnswers" :key="answer.id" :value="segment === 'poll' ? answer.content : answer.id">{{ answer.content || answer.tag }}</option>
		</select>
	</div>
</div>
</template>

<script>
export default {
	name: 'myRule',
	props: {
		rule: {},
	},
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
				groupId: this.$route.params.id,
			},
			segment: '',
			pollAndQuestion: '',
			condition: this.rule.name,
			field: this.rule.data.field,
			value: this.rule.data.value,
			group: {},
			myAnswer: {
			},
			myRule: this.rule,
		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		segments() {
			if (this.user.organization.is_mandatoaberto) {
				return Object.keys(this.conditions).filter(x => x !== 'gender'); // hide gender
			}
			return Object.keys(this.conditions).filter(x => x === 'intent');
		},
		polls() {
			return this.$store.state.group.polls.polls;
		},
		selectedPoll() {
			return this.$store.state.group.polls.polls;
		},
		intents() {
			const themes = (this.$store.state.entity.knowledges || {}).politician_entities || {};
			return themes;
		},
		availableConditions() {
			return this.segment
				? this.conditions[this.segment]
				: [];
		},
		conditions() {
			return this.$store.state.group.condition;
		},
		availableAnswers() {
			switch (this.segment) {
			case 'poll':
				return this.myAnswer;

			case 'intent':
				return this.intents;

			default:
				return {};
			}
		},
		answersPollReact() {
			return this.$store.state.group.answers.options;
		},
	},
	watch: {
		setGroup() {
			return this.$store.state.group.group;
		},
		conditions() {
			return this.$store.state.group.condition;
		},
		rule() {
			this.myRule = this.rule;
		},
	},
	methods: {
		getData() {
			if (this.$route.params.id) {
				this.getSegment();
				this.getCondition();
				this.getFilter();
				this.getPollAndQuestion();
			}
		},
		getSegment() {
			if (this.rule.name) {
				this.segment = this.segments.filter(x => this.conditions[x].filter(y => y.name === this.rule.name).length)[0] || '';
			}
		},
		getCondition() {
			if (this.rule.name) {
				this.condition = this.rule.name;
			}
		},
		getPollAndQuestion() {
			if (this.rule.data.field) {
				const [polls] = this.polls.filter(poll =>
					poll.questions
						.filter(question =>
							parseInt(question.id, 10) === parseInt(this.rule.data.field, 10)).length > 0);
				const pollId = polls.id;
				const question = this.rule.data.field;
				this.pollAndQuestion = [pollId, question].join(':');

				this.field = pollId;
				this.getAnswers();
			}
		},
		updateValue() {
			const ruleData = { name: '', data: {} };

			if (this.field) {
				ruleData.data.field = this.field;
			}

			if (this.condition) {
				ruleData.name = this.condition;
			}

			if (this.value) {
				ruleData.data.value = this.value;
			}

			this.$emit('input', ruleData);
		},
		getFilter() {
			if (this.segment === 'intent') {
				this.field = 0;
			}
			this.updateValue();
		},
		getAnswers() {
			const [poll, question] = this.pollAndQuestion.split(':');
			// eslint-disable-next-line
			this.field = parseInt(question);

			this.$store.dispatch('getAnswers', { poll, question }).then(() => {
				this.myAnswer = this.answersPollReact;
			});

			this.updateValue();
		},
	},
	mounted() {
		this.getData();
	},
};
</script>



// WEBPACK FOOTER //
// _source/javascripts/modules/group/myRule.vue